import { render, staticRenderFns } from "./lianxiwomen.vue?vue&type=template&id=a0d6b3e6&scoped=true"
import script from "./lianxiwomen.vue?vue&type=script&lang=js"
export * from "./lianxiwomen.vue?vue&type=script&lang=js"
import style0 from "./lianxiwomen.vue?vue&type=style&index=0&id=a0d6b3e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d6b3e6",
  null
  
)

export default component.exports